import React from 'react';
import { NodeViewWrapper, NodeViewProps } from '@tiptap/react';
import useScrollContent from '@modules/documents/hooks/useScrollContent.hook';
import { DOCUMENT_HTML_ATTRIBUTES } from '@modules/documents/constants';

const ScrollLinkView = ({ node }: NodeViewProps) => {
  const scrollContent = useScrollContent();

  const onClick = (e: React.MouseEvent<HTMLSpanElement>) => {
    e.preventDefault();
    e.stopPropagation();
    scrollContent({ value: node.attrs.targetId, attribute: DOCUMENT_HTML_ATTRIBUTES.CUSTOM_UNIQUE_ID });
  };

  return (
    <NodeViewWrapper as="span" className="import-warning" data-target-id={node.attrs.targetId} onClick={onClick}>
      {node.attrs.message}
    </NodeViewWrapper>
  );
};

export default React.memo(ScrollLinkView);
